import * as React from 'react';
import classnames from 'classnames';
import { Container } from '@grandvisionhq/elements';

const PromotionBanners = ({ children , fullWidth =false  })=>{
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('promotion-banners', {
            'promotion-banners--full-width': fullWidth
        })
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "promotion-banners__container"
    }, children));
};
var PromotionBanners$1 = PromotionBanners;

export { PromotionBanners$1 as default };
//# sourceMappingURL=PromotionBanners.js.map
